"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADT = exports.Type = void 0;
const prelude_1 = require("@packages/prelude");
const Name_1 = require("./Name");
exports.Type = prelude_1.t.union([Name_1.FirstName.Type, Name_1.SecondName.Type], 'Name');
exports.ADT = prelude_1.adt.fromUnion('class', exports.Type);
//# sourceMappingURL=Names.js.map